import React from 'react';
import styled from 'styled-components';
import { Col, Row, Table } from 'antd';
import AppTemplate from '../../templates/AppTemplate';
import TableSearch from '../../atoms/TableSearch';

const StyledTable = styled(Table)``;

const Settings = ({
  components,
  tableData,
  columns,
  loading,
  handleSearchTable,
  handleTableChange,
  pagination,
}) => (
  <AppTemplate>
    <h1>Settings</h1>

    <Row type="flex" justify="space-between" align="middle">
      <Col offset={20} span={4}>
        <TableSearch handleSearchTable={handleSearchTable} />
      </Col>
    </Row>

    <div className="tableContainer">
      <StyledTable
        size="middle"
        rowClassName={() => 'editable-row'}
        pagination={pagination}
        components={components}
        onChange={handleTableChange}
        rowKey="id"
        loading={loading}
        dataSource={tableData}
        columns={columns}
      />
    </div>
  </AppTemplate>
);

export default Settings;
